import { ArrowUpIcon, MessageCircleOff, XIcon } from "lucide-react";

import { cn } from "@/lib/utils";

import { Card, CardContent, CardFooter, CardHeader } from "../ui/card";
// import {
//   Command,
//   CommandEmpty,
//   CommandGroup,
//   CommandInput,
//   CommandItem,
//   CommandList,
// } from "../ui/command";
// import {
//   Dialog,
//   DialogContent,
//   DialogDescription,
//   DialogFooter,
//   DialogHeader,
//   DialogTitle,
// } from "../ui/dialog";
// import {
//   Tooltip,
//   TooltipContent,
//   TooltipProvider,
//   TooltipTrigger,
// } from "../ui/tooltip";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { useCallback, useEffect, useRef, useState } from "react";
import { addChatMessage, setChatMessages, type ChatMessage, type Participant } from "@/store/slices/callSlice";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "@/store";
import axios from "axios";
import { API_URL } from "@/constant";
interface ChatBotPageProps {
  participants: Participant[]; // Array of all participants in the call
  localUserId: string; // ID of the local user
  onClose?: () => void; // Optional close function for the dialog
  // setChatMessageReceivedCallback: (callback: () => void) => void; // New prop for callback
  sendRtcChatMessage: (message: string) => void;
}


export function ChatBotPage({ participants, localUserId, onClose,sendRtcChatMessage  }: ChatBotPageProps) {
  const [message, setMessage] = useState('');
  const chatMessages = useSelector((state: RootState) => state.call.chatMessages);
  const dispatch = useDispatch();
  const messagesEndRef = useRef<HTMLDivElement>(null);

  // Find the local user from the participants list
  const localUser = participants.find((p) => p.id === localUserId);

  // Function to fetch chat messages from the API
  const fetchChatMessages = useCallback(async () => {
    const requestId = localStorage.getItem("requestID");
    if (!requestId) {
      console.warn("DEBUG: RequestID not found in localStorage. Cannot fetch chat history.");
      return;
    }

    try {
      // console.log(`DEBUG: Fetching chat history from: ${API_ALL_CHAT}?RequestId=${requestId}`);
      const ALL_CHAT_URL = `${API_URL.API_ALL_CHAT}?RequestId=${requestId}`;

      const response = await axios.post(ALL_CHAT_URL, {}, {
          headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem("InteractionToken") || ""}`, 
        }
      }
      );

      console.log("DEBUG: AllChat API response:", response.data);

      // Adjusted to correctly parse response.data.Data
      if (response.data && response.data.Data && Array.isArray(response.data.Data)) {
        const apiMessages: ChatMessage[] = response.data.Data.map((chat: any) => {
          // Parse ISO 8601 date string to timestamp
          const timestamp = new Date(chat.CreatedAt).getTime();

          // Determine sender name for display
          const senderParticipant = participants.find(p => p.id === chat.SenderId);
          const senderName = senderParticipant ? senderParticipant.name : chat.SenderId; // Use participant name if found, else ID

          return {
            sender: senderName,
            message: chat.Text,
            timestamp: timestamp,
          };
        }).sort((a: ChatMessage, b: ChatMessage) => a.timestamp - b.timestamp); 

        dispatch(setChatMessages(apiMessages));
        console.log("DEBUG: Chat messages updated from API:", apiMessages);
      } else {
        console.warn("DEBUG: AllChat API response did not contain expected data structure (Data array).", response.data);
      }
    } catch (error) {
      console.error("DEBUG: Error fetching chat messages:", error);
      // Optionally dispatch an error message to chat
      dispatch(addChatMessage({ sender: "System", message: "Failed to load chat history.", timestamp: Date.now() })); // Used addChatMessage
    }
  }, [dispatch, participants]); // Add participants to dependencies

useEffect(() => {
    fetchChatMessages();
  }, [fetchChatMessages]);

  // Scroll to the bottom of the chat messages whenever they update
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [chatMessages]);

  const handleSendMessage = async () => {
    if (message.trim() === '') return;

    const requestId = localStorage.getItem("requestID");
    if (!requestId) {
      console.warn("DEBUG: RequestID not found in localStorage. Cannot send message.");
      dispatch(addChatMessage({ sender: "System", message: "Cannot send message: Request ID missing.", timestamp: Date.now() })); // Used addChatMessage
      return;
    }

    const AgentName = localStorage.getItem("AgentName") ; 
    const senderId = localUserId; 
    const receiverId = AgentName; 

    const payload = {
      ID: 0, 
      ReceiverId: receiverId,
      Request_Id: requestId,
      SenderId: senderId,
      Text: message.trim(),
    };

    dispatch(addChatMessage({ 
      sender: localUser?.name || "You",
      message: message.trim(),
      timestamp: Date.now(),
    }));
    setMessage('');

    try {
      console.log("DEBUG: Sending chat message payload:", payload);
      const response = await axios.post(API_URL.API_INSERT_CHAT, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem("InteractionToken") || ""}`, 
        },
      });
      console.log("DEBUG: InsertChat API response:", response.data);

      if (response.status === 200) {
        console.log("DEBUG: Message sent successfully via API.");
        // Trigger a re-fetch of all chat messages to ensure consistency
        sendRtcChatMessage(payload.Text);
        // fetchChatMessages();

      } else {
        console.error("DEBUG: Failed to send message via API:", response.data);
        dispatch(addChatMessage({ sender: "System", message: "Failed to send message.", timestamp: Date.now() })); // Used addChatMessage
      }
    } catch (error) {
      console.error("DEBUG: Error sending chat message:", error);
      dispatch(addChatMessage({ sender: "System", message: `Error sending message: ${error instanceof Error ? error.message : String(error)}.`, timestamp: Date.now() })); // Used addChatMessage
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSendMessage();
    }
  };

  return (
    <div className="w-full h-fit border-blue-300 bg-blue-100 shadow-lg">
      <Card className="w-full h-full  border-blue-300 bg-blue-100 border-1  shadow-lg ">
        <CardHeader className="flex flex-row px-3 md:py-0 py-2  justify-between">
          <div className="flex items-center gap-4">
            <Avatar className="border font-semibold">
              <AvatarImage
                src={localUser?.avatar || "you"}
                alt="Image"
              />
              <AvatarFallback>
                {localUser?.name.charAt(0) || "You"}
              </AvatarFallback>
            </Avatar>
            <div className="flex flex-col gap-0.5">
              <p className="text-sm leading-none font-medium">
                {localUser?.name || "You"}
              </p>
              <p className="text-muted-foreground text-xs">
                {localUser?.name || ""}
              </p>
            </div>
          </div>
          {/* <TooltipProvider delayDuration={0}>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  size="icon"
                  variant="secondary"
                  className="ml-auto size-8 bg-blue-200 rounded-full"
                >
                  <PlusIcon />
                  <span className="sr-only">New message</span>
                </Button>
              </TooltipTrigger>
              <TooltipContent sideOffset={10}>New message</TooltipContent>
            </Tooltip>
          </TooltipProvider> */}
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            className="rounded-full p-0 w-8 h-8 bg-blue-200 hover:bg-[#f9c700]"
          >
            <XIcon className="h-5 w-5" />
            <span className="sr-only">Close Chat</span>
          </Button>
        </CardHeader>
        <CardContent className="px-2 md:h-80 h-[68vh] overflow-y-auto">
          <div>
            <div className="flex p-0 md:pt-0 pt-5 flex-col gap-4">
              {chatMessages.length === 0 ? (
                <div className="flex flex-col items-center justify-center h-full text-gray-500 text-center py-10">
                  <MessageCircleOff className="h-10 w-10 mb-2" />
                  <p>No messages yet. Start the conversation!</p>
                </div>
              ) : (
                chatMessages.map((msg, index) => {
                  const isLocalUserMessage = msg.sender === (localUser?.name || "You");
                  const senderName = msg.sender === "System" ? "System" : msg.sender;

                  return (
                    <div
                      key={index} 
                      className={`flex ${isLocalUserMessage ? 'justify-end' : 'justify-start'}`}
                    >
                      <div className="flex items-center gap-2">
                        {!isLocalUserMessage && (
                          <Avatar className="border-none">
                            <AvatarImage
                              src={participants.find(p => p.name === msg.sender)?.avatar || "/avatars/02.png"}
                              alt={senderName}
                            />
                            <AvatarFallback className="font-semibold bg-[#fdc300] text-sm ">{senderName ==="System" ? `${senderName.charAt(0)}` : "CCE"}</AvatarFallback>
                          </Avatar>
                        )}
                        <div
                          className={cn(
                            "flex w-max max-w-56 flex-col gap-2 rounded-lg  pb-2 text-sm",
                            isLocalUserMessage
                              ? "bg-[#13a8e1] py-2 px-3 text-primary-foreground font-medium ml-auto"
                              : "bg-[#f9c700] py-2 px-3 text-black font-medium"
                          )}
                        >
                          {!isLocalUserMessage && senderName === "System" && (
                            <div className="font-medium text-sm bg-white rounded-xl w-full p-2 text-black">
                              {senderName}
                            </div>
                          )}
                          <p className="text-sm break-words">{msg.message}</p>
                          <div className={`text-xs mt-1 ${isLocalUserMessage ? 'text-blue-900' : 'text-gray-900'}`}>
                            {new Date(msg.timestamp).toLocaleTimeString([], {  hour: '2-digit', minute: '2-digit' })}
                          </div>
                        </div>
                        {isLocalUserMessage && (
                          <Avatar className="border-none">
                            <AvatarImage
                              src={localUser?.avatar || "/avatars/01.png"}
                              alt={localUser?.name || "You"}
                            />
                            <AvatarFallback>{localUser?.name.charAt(0) || "Y"}</AvatarFallback>
                          </Avatar>
                        )}
                      </div>
                    </div>
                  );
                })
              )}
              <div ref={messagesEndRef} /> 
            </div>
          </div>
        </CardContent>
        <CardFooter className="flex items-center gap-2  px-2 md:mt-2 ">
          <form
            onSubmit={(event) => {
              event.preventDefault();
              handleSendMessage();
            }}
            className="relative w-full "
          >
            <Input
              id="message"
              placeholder="Type your message..."
              className="flex-1 pr-10 border-1 border-[#f9c700] focus:ring-0 focus:ring-[#0094ff] bg-blue-50 text-black placeholder:text-muted-foreground"
              autoComplete="off"
              value={message}
              onChange={(event) => setMessage(event.target.value)}
              onKeyDown={handleKeyDown}
            />
            <Button
              type="submit"
              size="icon"
              className="absolute top-1/2 right-2 bg-[#fdc300] text-black  size-6 -translate-y-1/2 rounded-full"
              disabled={message.trim().length === 0}
            >
              <ArrowUpIcon className="size-3.5 " />
              <span className="sr-only">Send</span>
            </Button>
          </form>
        </CardFooter>
      </Card>
      {/* Dialog for new message/user selection - retained from your previous code */}
      {/* Note: The `setOpen` state and `Dialog` component are not directly connected to chat API for now */}
      {/* You might want to remove or re-purpose this if not needed for API chat. */}
      {/* For simplicity, I've commented out the `setOpen(true)` call on the PlusIcon button for now. */}
      {/* <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="gap-0 p-0 bg-blue-50 outline-none">
          <DialogHeader className="px-4 pt-5 pb-4">
            <DialogTitle>New message</DialogTitle>
            <DialogDescription>
              Invite a user to this thread. This will create a new group
              message.
            </DialogDescription>
          </DialogHeader>
          <Command className="overflow-hidden rounded-t-none border-t bg-transparent">
            <CommandInput placeholder="Search user..." />
            <CommandList>
              <CommandEmpty>No users found.</CommandEmpty>
              <CommandGroup>
                {participants.map((user) => (
                  <CommandItem
                    key={user.id}
                    data-active={selectedUsers.some((su) => su.id === user.id)}
                    className="data-[active=true]:opacity-50"
                    onSelect={() => {
                      if (selectedUsers.some((su) => su.id === user.id)) {
                        return setSelectedUsers(
                          selectedUsers.filter(
                            (selectedUser) => selectedUser.id !== user.id
                          )
                        );
                      }

                      return setSelectedUsers(
                        [...participants].filter(
                          (
                            p // Filter from all participants
                          ) =>
                            [...selectedUsers, user].some(
                              (su) => su.id === p.id
                            ) // Check by ID
                        )
                      );
                    }}
                  >
                    <Avatar className="border">
                      <AvatarImage src={user.avatar} alt="Image" />
                      <AvatarFallback>{user.name[0]}</AvatarFallback>
                    </Avatar>
                    <div className="ml-2">
                      <p className="text-sm leading-none font-medium">
                        {user.name}
                      </p>
                      <p className="text-muted-foreground text-sm">
                        {user.email || "No email"}
                      </p>
                    </div>
                    {selectedUsers.some((su) => su.id === user.id) ? (
                      <CheckIcon className="text-primary ml-auto flex size-4" />
                    ) : null}
                  </CommandItem>
                ))}
              </CommandGroup>
            </CommandList>
          </Command>
          <DialogFooter className="flex items-center border-t p-4 sm:justify-between">
            {selectedUsers.length > 0 ? (
              <div className="flex -space-x-2 overflow-hidden">
                {selectedUsers.map((user) => (
                  <Avatar key={user.id} className="inline-block border">
                    <AvatarImage src={user.avatar} />
                    <AvatarFallback>{user.name[0]}</AvatarFallback>
                  </Avatar>
                ))}
              </div>
            ) : (
              <p className="text-muted-foreground text-sm">
                Select users to add to this thread.
              </p>
            )}
            <Button
              disabled={selectedUsers.length < 2}
              size="sm"
              onClick={() => {
                setOpen(false);
                setSelectedUsers([]);
              }}
            >
              Continue
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog> */}
    </div>
  );
}